export default __webpack_public_path__ + "img/ThumbVideo.0f33d345.png";